import React from 'react';

import './span-banner.scss';

const SpanBanner = props => {

    const { mobile } = props;

    return (
        <>
            {!mobile ?
                <>
                    <span className="f-curve-height"></span>
                    <span className="f-circle-log">
                        <span className="f-circle-log-child" />
                    </span>
                    <span className="f-curve-effect f-curve-effect-one">
                        <span className="f-curve-child-bottom"></span>
                    </span>
                </>
                :
                <>
                    <span className="f-curve-height-mobile"></span>
                    <span className="f-circle-log-mobile">
                        <span className="f-circle-log-child-mobile" />
                    </span>
                    <span className="f-curve-effect-mobile f-curve-effect-one-mobile">
                        <span className="f-curve-child-bottom-mobile"></span>
                    </span>
                </>
            }
        </>
    )
}

export default SpanBanner;